import React from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { I18n } from 'react-polyglot';
import languages from "./Assets/Language/Langloader";

import MainMenu from "./Components/Shared/MainMenu/MainMenu";
import Dashboard from './Components/Pages/Dashboard/Dashboard';
import LastEvents from "./Components/Pages/LastEvents/LastEvents";
import Users from "./Components/Pages/Users/Users";
import Resources from "./Components/Pages/Resources/Resources";
import Organisation from "./Components/Pages/Organisation/Organisation";
import Login from "./Components/Pages/Login/Login";
import PrivateRoute from "./PrivateRoute";
import { ProvideAuth } from "./Auth";
import Settings from "./Components/Pages/Settings/Settings";
import LocaleHandler from "./LocaleHandler";
import MyAccount from "./Components/Pages/MyAccount/MyAccount";
import Deals from './Components/Pages/Deals/Deals';
import Persons from './Components/Pages/Persons/Persons';
import BookingSingle from "./Components/Pages/BookingSingle/BookingSingle";
import Bookings from "./Components/Pages/Bookings/Bookings";
import Events from "./Components/Pages/Events/Events";
import ResourceBookingOverview from "./Components/Pages/ResourceBookingOverview/ResourceBookingOverview";
import Maintenance from "./Components/Pages/Maintenance/Maintenance";
import Customers from "./Components/Pages/Customers/Customers";
import EventSingle from "./Components/Pages/EventSingle/EventSingle";
import ResetPassword from "./Components/Pages/LostPassword/ResetPassword";
import LostPassword from "./Components/Pages/LostPassword/LostPassword";
import EventExternal from "./Components/Pages/EventExternal/EventExternal";


export default function Application() {
    let localeTemp = "no";
    if (localStorage.getItem("user") != null) {
        let localUser = localStorage.getItem("user");
        if (localUser != null) {
            localUser = JSON.parse(localUser);
            if (localUser != null) {
                if (localUser["userdata"]["language"] != undefined) {
                    localeTemp = localUser["userdata"]["language"].toLowerCase();
                }
            }
        }
    }
    let languageTemp: any = {};
    languageTemp = languages(localeTemp);
    

    const [locale, setLocale] = React.useState(localeTemp);
    const [messages, setMessages] = React.useState(languageTemp);

    React.useEffect(
        () => {
            if (localStorage.getItem("user") != null) {
                let localUser = localStorage.getItem("user");
                if (localUser != null) {
                    localUser = JSON.parse(localUser);
                    if (localUser != null) {
                        if (localUser["userdata"]["language"] != undefined) {
                            setLocale(localUser["userdata"]["language"].toLowerCase());
                        }
                    }
                }
            }
            setMessages(languages(locale));
        }, [locale]
    )

    return (
        <LocaleHandler.Provider value={{ locale, setLocale }}>
            <ProvideAuth>
                <I18n locale={locale} messages={messages}>
                    <Router>
                        <div>
                            <ToastContainer />
                            <MainMenu />
                            <Switch>
                                <PrivateRoute exact path="/" component={Dashboard} />
                                <Route path="/login">
                                    <Login />
                                </Route>
                                <Route path="/lastevents">
                                    <LastEvents />
                                </Route>
                                <Route path="/users">
                                    <Users />
                                </Route>
                                <Route path="/resources">
                                    <Resources />
                                </Route>
                                <Route path="/events">
                                    <Events />
                                </Route>
                                <Route path="/resourcebooking">
                                    <ResourceBookingOverview />
                                </Route>
                                <Route path="/organisation">
                                    <Organisation />
                                </Route>
                                <Route path="/settings">
                                    <Settings />
                                </Route>
                                <Route path="/myaccount">
                                    <MyAccount />
                                </Route>
                                <Route path="/deals">
                                    <Deals />
                                </Route>
                                <Route path="/persons">
                                    <Persons />
                                </Route>
                                <Route path="/bookings">
                                    <Bookings />
                                </Route>
                                <Route path="/booking/:id">
                                    <BookingSingle />
                                </Route>
                                <Route path="/maintenance">
                                    <Maintenance />
                                </Route>
                                <Route path="/booking">
                                    <BookingSingle />
                                </Route>
                                <Route path="/event/:id">
                                    <EventSingle />
                                </Route>
                                <Route path="/event">
                                    <EventSingle />
                                </Route>
                                
                                <Route path="/customers">
                                    <Customers />
                                </Route>
                                
                                <Route path="/lostpassword/:token">
                                        <ResetPassword />
                                </Route>
                                <Route path="/lostpassword">
                                    <LostPassword />
                                </Route>
                                <Route path="/eventexternal">
                                    <EventExternal />
                                </Route>
                            </Switch>
                        </div>
                    </Router>
                </I18n>
            </ProvideAuth>
        </LocaleHandler.Provider>
    );
}